import styled from "@emotion/styled";
import { Container, FlexRow, H2, HeadingGroup, Link, Stack } from "atoms";
import { useFeed } from "../api/usePosts";
import { Feed } from "./Feed";

type CollectiveFeedProps = {
  id: string;
};

/**
 * Most recent artist updates (no filters, up to 4 showing)
 */
function CollectiveFeed({ id }: CollectiveFeedProps) {
  const { data: artistFeed } = useFeed(
    new URLSearchParams({ badge: id, perPage: "4" })
  );

  const posts = artistFeed?.pages?.[0].data ?? [];
  if (posts.length === 0) return null;

  return (
    <SSection>
      <Container width="lg">
        <Stack as="section" gap="md">
          <FlexRow alignItems="flex-end" justifyContent="space-between">
            <HeadingGroup>
              <H2 size="h3">Updates from our artists</H2>
            </HeadingGroup>
            <Link to={`/collectives/${id}/updates`} variant="primary" size="xs">
              All Updates from This Collective
            </Link>
          </FlexRow>

          <SFeed posts={posts} showArtist />
        </Stack>
      </Container>
    </SSection>
  );
}

const SFeed = styled(Feed)(({ theme }) => ({
  gap: "1rem",
  [theme.breakpoints.tablet]: {
    gridTemplateColumns: `repeat(2, calc(50% - (${theme.spacing.gap} / 2)))`,
  },
  [theme.breakpoints.desktop]: {
    gridTemplateColumns: `repeat(3, calc((100% / 3) - (${theme.spacing.gap} / 1.5)))`,
    "&>div:nth-of-type(4)": {
      display: "none",
    },
  },
  [theme.breakpoints.desktopLarge]: {
    gridTemplateColumns: `repeat(4, calc(25% - (${theme.spacing.gap} * .375)))`,
    "&>div:nth-of-type(4)": {
      display: "flex",
    },
  },
}));

const SSection = styled.section({
  position: "relative",
  zIndex: 3,
});

export { CollectiveFeed };
